import { render, staticRenderFns } from "./VenueRecipes.vue?vue&type=template&id=2be04d42&"
import script from "./VenueRecipes.vue?vue&type=script&lang=js&"
export * from "./VenueRecipes.vue?vue&type=script&lang=js&"
import style0 from "./VenueRecipes.vue?vue&type=style&index=0&id=2be04d42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports